<ng-template #autoRenewalFailedAlert>
  <div class="d-flex align-items-center justify-content-start">
    <span class="mr-1">{{ 'shared:licenses.autoRenewalFailed' | i18next }}</span>
    <div *ngIf="!(isShareIt | async)">
      {{ 'shared:licenses.checkYour' | i18next }}
      <mbs-payment-method-button></mbs-payment-method-button>
      or
      <mbs-button type="primary" [isCtrl]="true" size="inherit"
                  (click)="openRenewModal()">{{ 'shared:licenses.tryRenewAgain' | i18next }}</mbs-button>
    </div>
  </div>
</ng-template>
